<template>
  <div class="labeled-beneficiary-selector">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <BeneficiarySelector
      ref="beneficiarySelector"
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :privilege="privilege"
      :privileges="privileges"
      :empty-text="emptyText"
      @beforeChange="onBeforeChange"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </BeneficiarySelector>
  </div>
</template>

<script>
import BeneficiarySelector from '../beneficiary-selector';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Виберіть привілей',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    privilege: {
      type: [String, Number, Object, null],
      default: null,
    },
    privileges: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  data() {
    return {
      inputId: `beneficiary-selector-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, BeneficiarySelector },
  computed: {
    getBeneficiarySelector() {
      return this.$refs.beneficiarySelector;
    }
  },
  methods: {
    generateRandomId,
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    },
  },
};
</script>
